Jelly.Actions.Add_Hidden_Value = function(Parameters) { 
	// Namespace, Input_Alias, Value
	// Get values wrapper
	// TODO - this will get the top-most values_wrapper kind of just happenstance, because the templates always put their values wrapper before their content.  The content might nest actions, but their values wrapper will come second
	// TODO - I think we couldn't do '_Values_Wrapper' because of something regarding Calling_Namespace, but check any Flow Action that creates an object to verify
	var Values_Wrapper = $('#' + Parameters["Namespace"] + " .Values_Wrapper").eq(0);
	
	// Get action namespace
	var Action_Namespace = Jelly.References.Get_Reference_For_Element(Values_Wrapper.get(0)).Namespace;
	
	// Get the specific input, or create it if it doesn't exist.
	var Value_Input = $(Jelly.Actions.Get_Input_From_Action_By_Alias({Namespace: Action_Namespace, Alias: Parameters["Input_Alias"]}));
	if (!Value_Input.length) { 
	
		// Create input
		Value_Input = $('<input/>', { 
			class: "Value",
			type: 'hidden',
			id: Action_Namespace + "_Value_Input_" + Parameters["Input_Alias"],
			name: Parameters["Input_Alias"]
		})	
		
		// Add it to DOM
		Values_Wrapper.append(Value_Input);
		
		// Register input to the action namespace.
		Jelly.Actions.Register_Action_Input({
			Namespace: Action_Namespace,
			Element: Value_Input.get(0)
		});

	}
	
	// Set the value
	Value_Input.val(Parameters["Value"]);
	
};